import React from 'react';
import { Col, HeadingText, BodyText, PAYPAL_THEME } from '@paypalcorp/pp-react';
import PropTypes from 'prop-types';
import styles from './stepperStyles.less';

const StepperHeader = (props) => {
  const { header, subHeader, isMobileView, isPrimaryModule, children } = props;

  return (
    <Col key='headerComponent' sm={6} xs={12}>
      <div className={styles.stepperContainer}>
        <HeadingText
          style={{
            color: isPrimaryModule
              ? PAYPAL_THEME.sysColorSystemMain
              : PAYPAL_THEME.sysColorPrimaryContrast,
          }}
          size={isMobileView ? 'sm' : 'lg'}
        >
          {header}
        </HeadingText>
        <BodyText
          style={{
            color: isPrimaryModule
              ? PAYPAL_THEME.sysColorSystemMain
              : PAYPAL_THEME.sysColorPrimaryContrast,
          }}
          className={styles.stepperContainerFont}
        >
          {subHeader}
        </BodyText>
        {children}
      </div>
    </Col>
  );
};

StepperHeader.propTypes = {
  header: PropTypes.string.isRequired,
  subHeader: PropTypes.string.isRequired,
  isMobileView: PropTypes.bool,
  isPrimaryModule: PropTypes.bool.isRequired,
};

StepperHeader.defaultProps = {
  isMobileView: false,
};

export { StepperHeader };
